export enum Theme {
	GREEN = 'green',
	PURPLE = 'purple',
}
